//Page Components
import Features1 from "../components/FeaturesFirstPage";
import Features2 from "../components/FeaturesSecondPage";
import Features3 from "../components/FeaturesThirdPage";

const Features = () => {
  return (
    <div>
      <Features1 />
      <Features2 />
      <Features3 />
    </div>
  );
};

export default Features;
